var _path, _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClear(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4C0 1.79086 1.79086 0 4 0H12C14.2091 0 16 1.79086 16 4V12C16 14.2091 14.2091 16 12 16H4C1.79086 16 0 14.2091 0 12V4Z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2009_60124",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#E8E8E8"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2009_60124)"
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M2.62658 2.62348C2.33369 2.91638 2.33369 3.39125 2.62658 3.68414L6.69238 7.74994L2.62646 11.8159C2.33357 12.1088 2.33357 12.5836 2.62646 12.8765C2.91935 13.1694 3.39423 13.1694 3.68712 12.8765L7.75304 8.8106L11.819 12.8765C12.1119 13.1694 12.5867 13.1694 12.8796 12.8765C13.1725 12.5836 13.1725 12.1088 12.8796 11.8159L8.8137 7.74994L12.8795 3.68413C13.1724 3.39124 13.1724 2.91637 12.8795 2.62347C12.5866 2.33058 12.1117 2.33058 11.8188 2.62347L7.75304 6.68928L3.68724 2.62348C3.39435 2.33059 2.91947 2.33059 2.62658 2.62348Z",
    fill: "#54565B"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClear);
export default __webpack_public_path__ + "static/media/clear.eb03cb0498fa68912ee97d1284130180.svg";
export { ForwardRef as ReactComponent };